module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0024.jpg?v=fec1cee3";